<!--
 * @Author: your name
 * @Date: 2020-07-29 19:38:49
 * @LastEditTime: 2022-09-08 16:12:35
 * @LastEditors: yggira ira1982@gmail.com
 * @Description: In User Settings Edit
 * @FilePath: /intelligent-parking/src/App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import Util from "./Util"
  export default {
    name: 'App',
    data() {
      return {
        lastTime: new Date().getTime(),
        currentTime: new Date().getTime(),
        timeOut: 1000 * 60 * 100
      }
    },
    mounted() {
      /* 定时器  间隔1秒检测是否长时间未操作页面  */
      window.setInterval(this.testTime, 1000)
      if (window.addEventListener) //FF,火狐浏览器会识别该方法
        window.addEventListener('DOMMouseScroll', this.wheel, false);
        window.addEventListener('click', this.handle);
        window.addEventListener('dbclick', this.handle);
        window.addEventListener('mousemove', this.handle);
        window.addEventListener('keydown', this.handle);
        window.addEventListener('keypress', this.handle);
        window.addEventListener('keyup', this.handle);
        window.onmousewheel = document.onmousewheel = this.wheel; //W3C
    },
    methods: {
      wheel(event) {
        var delta = 0;
        if (!event) event = window.event;
        if (event.wheelDelta) { //IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
          delta = event.wheelDelta / 120;
          if (window.opera) delta = -delta; //因为IE、chrome等向下滚动是负值，FF是正值，为了处理一致性，在此取反处理
        } else if (event.detail) { //FF浏览器使用的是detail,其值为“正负3”
          delta = -event.detail / 3;
        }
        if (delta)
          this.handle(delta);
      },
      testTime() {
        this.currentTime = new Date().getTime(); //更新当前时间
        if (this.currentTime - this.lastTime > this.timeOut) { //判断是否超时
          if (Util.getCookie('token') && this.$route.name != "workbench") {
            this.outSubmit()
            alert("您太久没有操作了，请重登！");
            Util.delCookie('token')
            location.href = '/Login'
          }
        }
      },
      handle(delta) {
        this.lastTime = new Date().getTime(); //更新操作时间

      },
      //   退出登录
      outSubmit() {
        this.$http.post(`${Util.operateURL}deviceManage/logout`).then(
          res => {
            if (res.data.code === 200) {

            }
          },
          err => {
            console.log(err);
          }
        );
      },
    }
  }

</script>

<style>
  @import './assets/less/common.less'

</style>



// WEBPACK FOOTER //
// src/App.vue